module.exports = __webpack_public_path__ + "jsj_h5_static/img/ic_onebuy02.841763e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/ic_onebuy02.png
// module id = 0w59
// module chunks = 35